import { Card } from './Card'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'

export const LengthOfService = ({ data, isLoading, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='Length of Service'
            filterTitle='Filter Length of Service'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative w-full h-full'>
                <ResponsiveContainer style={{ height: 'auto', paddingBottom: 35, marginLeft: -20 }}>
                    <BarChart data={data}>
                        <XAxis dataKey='length_of_service' tick={{ fontSize: 10 }} />
                        <YAxis tick={{ fontSize: 10 }} />
                        <Tooltip />
                        <Bar dataKey='total' fill='#0ea5e9' name='Total' radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>

                {!data?.length && (
                    <div className='absolute inset-0 flex items-center justify-center font-semibold text-neutral-60'>
                        Data Not Available
                    </div>
                )}
            </div>
        </Card>
    )
}
